import BaseSchema from './schema';
import NotImplementedException from '../exceptions/NotImplementedException';

function getSchema(name) {
  const schema = BaseSchema[name];
  if (!schema) {
    throw new NotImplementedException('getSchema must be implemented');
  }
  return schema;
}

export default { getSchema };
